import { z } from 'zod';

export const releaseNoteItemSchema = z.object({
  category: z.coerce.number().min(0).max(4),
  platform: z.coerce.number().min(0).max(3),
  description: z
    .string()
    .min(1, 'Description is required')
    .max(500, 'Description must not exceed 500 characters'),
  sortOrder: z.coerce.number().min(0),
});

export const releaseHighlightItemSchema = z.object({
  moduleName: z
    .string()
    .min(1, 'Module name is required')
    .max(100, 'Module name must not exceed 100 characters'),
  content: z
    .string()
    .min(1, 'Content is required')
    .max(4000, 'Content must not exceed 4000 characters'),
  sortOrder: z.coerce.number().min(0),
});

export const releaseSchema = z.object({
  webVersion: z
    .string()
    .min(1, 'Web version is required')
    .max(20, 'Web version must not exceed 20 characters'),
  mobileVersion: z
    .string()
    .min(1, 'Mobile version is required')
    .max(20, 'Mobile version must not exceed 20 characters'),
  title: z
    .string()
    .min(1, 'Title is required')
    .max(200, 'Title must not exceed 200 characters'),
  summary: z
    .string()
    .max(2000, 'Summary must not exceed 2000 characters')
    .nullable(),
  releaseDate: z.string().min(1, 'Release date is required'),
  isPublished: z.boolean(),
  notes: z.array(releaseNoteItemSchema),
  highlights: z.array(releaseHighlightItemSchema),
});

export type ReleaseFormData = z.infer<typeof releaseSchema>;
export type ReleaseNoteItemFormData = z.infer<typeof releaseNoteItemSchema>;
export type ReleaseHighlightItemFormData = z.infer<
  typeof releaseHighlightItemSchema
>;
